// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getFirestore,
  serverTimestamp,
  addDoc,
  collection
} from "firebase/firestore";

import {
  getAuth,
  signInAnonymously,
  onAuthStateChanged
} from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyC4E835b25gEBSQtbEcBNVMGeHMpBh8h_M",
  authDomain: "bubblebutter-7c880.firebaseapp.com",
  projectId: "bubblebutter-7c880",
  storageBucket: "bubblebutter-7c880.firebasestorage.app",
  messagingSenderId: "109075309912",
  appId: "1:109075309912:web:ffd01bf9cc54d49c4ab12d",
  measurementId: "G-SEY270TLBW"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Firestore
export const db = getFirestore(app);

// Auth
export const auth = getAuth(app);

/**
 * IMPORTANT FIX:
 * Anonymous sign-in only happens if user is NOT logged in.
 * This avoids:
 *   ❌ "auth/admin-restricted-operation"
 *   ❌ Conflicts with normal login
 *   ❌ Breaking admin permissions
 */
onAuthStateChanged(auth, (user) => {
  if (!user) {
    signInAnonymously(auth).catch((err) => {
      console.warn("Anonymous sign-in failed:", err);
    });
  }

  console.log("Firebase Auth User:", user ? user.uid : "No user");
});


/**
 * Create an order in Firestore
 * order = { customer: {...}, items: [...], total }
 */
export async function createOrder(order) {
  // Generate 8-digit custom order number
  const shortId = "BB-" + Math.floor(10000000 + Math.random() * 90000000);

  const docRef = await addDoc(collection(db, "orders"), {
    ...order,
    orderNumber: shortId,
    createdAt: serverTimestamp(),
  });

  return { firestoreId: docRef.id, orderNumber: shortId };
}
